import React from 'react';
import PropTypes from 'prop-types';
import Button from '@Components/Button';
import { EXPORT_TYPES } from '@Services/ExportService/ExportConstants';

import './ExportTabTooltipHeader.custom.scss';

function ExportTabTooltipHeader(props) {
  const { exportType, close } = props;

  return (
    <div className="exportTab__tooltip_header">
      <h4 className="u-els-font-size-h3">{exportType === EXPORT_TYPES.CHEMQUOTE ? 'ChemQuote Exports' : 'Exports'}</h4>
      <Button
        type="button"
        onClick={close}
        buttonConfig={{
          type: 'link',
          size: 'xs',
          e2eName: 'export-tab-tooltip-button',
          iconOnly: true,
        }}
        iconConfig={{
          name: 'delete',
        }}
      />
    </div>
  );
}

ExportTabTooltipHeader.propTypes = {
  exportType: PropTypes.string,
  close: PropTypes.func.isRequired,
};

export default ExportTabTooltipHeader;
